import { gql } from '@apollo/client';

export const BOOKMARK_QUESTION = gql(/*GraphQL*/ `
mutation BookmarkQuestionForUser($questionId: ID!) {
  bookmarkQuestionForUser(questionId: $questionId)
}
`);
